import React, { Component } from 'react';
import Hero from '../modules/Hero/Hero';
import SecondHeading from '../modules/SecondHeading';
import ImagePanel from '../modules/ImagePanel';
import ThreeColumnIcons from '../modules/ThreeColumnIcons/ThreeColumnIcons';
import RegisterBlock from '../modules/RegisterBlock';
import TwoPanel from '../modules/TwoPanel';
import globals from '../globals';
import HelmetDefault from "../layout/HelmetDefault";

class Voip extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            secondHeading: {},
            imagePanel1: {},
            imagePanel2: {},
            imagePanel3: {},
            threeColumnIcons: {},
            twoPanel: {},
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/voip/overview')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <SecondHeading data={this.state.secondHeading} />
                <ImagePanel
                    data={this.state.imagePanel1}
                    align="left"
                />
                <ImagePanel
                    data={this.state.imagePanel2}
                    align="right"
                />
				<ImagePanel
					data={this.state.imagePanel3}
					align="left"
				/>
                <ThreeColumnIcons data={this.state.threeColumnIcons} dataReceived={this.state.dataReceived} />
                <TwoPanel
                    data={this.state.twoPanel}
                    buttonImages={[
                        '/images/btn-learn-more-darkgreen.svg',
                        '/images/btn-learn-more-white.svg'
                    ]}
                />
                <RegisterBlock />
            </div>
        );
    }

}

export default Voip;


// WEBPACK FOOTER //
// ./resources/assets/js/voip/Voip.js